import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyBrF3EljJ6MrU1ojGzgeZVYubfaWLwHD4g",
  authDomain: "blogcrypto-react-app.firebaseapp.com",
  projectId: "blogcrypto-react-app",
  storageBucket: "blogcrypto-react-app.appspot.com",
  messagingSenderId: "344188304493",
  appId: "1:344188304493:web:b0f7e935ef1720fcb65364"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const store = getFirestore(app);